// extracted by mini-css-extract-plugin
export var subtitle = "_df-2";
export var title = "_df-0";
export var titleNoWrap = "_df-1";